import { AvailableIcon } from "src/ccl/document";

type FooterLinkType = {
  link: string;
  text: string;
  external: boolean;
  amplitudeEvent?: string;
  eventName?: string;
  isCookies?: boolean;
  isCreateJob?: boolean;
};

export const FooterLinks: FooterLinkType[] = [
  {
    link: "/jobs/new/shortlist",
    text: "Create a job",
    external: false,
    amplitudeEvent: "footer - book talent",
    isCreateJob: true,
  },
  { link: "/about", text: "About us", external: false },
  {
    link: "/backstage",
    text: "Backstage",
    external: false,
    amplitudeEvent: "footer - backstage blog",
  },
  { link: "/terms", text: "Terms", external: false },
  { link: "/privacy", text: "Privacy", external: false },
  {
    link: "/",
    text: "Cookies",
    external: false,
    eventName: "footer:cookies",
    isCookies: true,
  },
  {
    link: "mailto:help@contact.xyz",
    text: "Help",
    external: true,
    eventName: "footer:contact",
  },
];

type SocialLinkType = {
  accessibleName: string;
  link: string;
  iconVariant: AvailableIcon;
};

export const SocialLinks: SocialLinkType[] = [
  {
    accessibleName: "Contact on Instagram",
    link: "https://www.instagram.com/contact.xyz",
    iconVariant: "instagram",
  },
  {
    accessibleName: "Contact on LinkedIn",
    link: "https://www.linkedin.com/company/contact-creatives/",
    iconVariant: "linkedIn",
  },
  {
    accessibleName: "Contact on TikTok",
    link: "https://www.tiktok.com/@contact.creatives",
    iconVariant: "tiktok",
  },
];
